<template>
	<div>
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
			<div class="bg-white padding-xl">
				<div class="flex justify-between">
					<div class="text-lg flex" style="line-height:40px;">
						<div style="width:100px;" class="text-right">
							<span class="text-grey">会员编号：</span>
						</div>
						<div class="padding-left">
							<span class="text-bold text-black text-xxl">{{userid}}</span>
						</div>
					</div>
					<div class="">
						<Button type="warning" size="large" @click="modalModifyShow=true" icon="ios-create-outline">修改</Button>
					</div>
				</div>
				<Divider />
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">登陆账号：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.username}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">账号状态：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<Tag color="warning" v-if="info.stateflag=='0'">无效</Tag>
							<Tag color="primary" v-if="info.stateflag=='1'">正常</Tag>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">姓名：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.nickname}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">手机：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.mobile}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">注册时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.addtime}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">更新时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.updatetime}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">登陆次数：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.logintimes}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">最后登陆：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.lastlogintime}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Divider orientation="left">身份证信息</Divider>
				<div class="padding-xl">
					<Row v-if="info.idcard">
						<Col span="12">
						<div class="padding-xl text-center">
							<img :src="'http://cjb.xahulian.com/'+info.idcard.img_url.z" style="width:100%" />
						</div>
						</Col>
						<Col span="12">
						<div class="padding-xl text-center">
							<img :src="'http://cjb.xahulian.com/'+info.idcard.img_url.f" style="width:100%" />
						</div>
						</Col>
					</Row>
					<div class="text-red padding-lg" v-else>
						<Icon type="ios-alert-outline" /> 未上传！
					</div>
				</div>
				<Divider orientation="left">驾照信息</Divider>
					<div class="padding-xl text-center" v-if="info.jiazhao">
						<img :src="'http://cjb.xahulian.com/'+info.jiazhao.img_url" style="width:100%" />
					</div>
					<div class="text-red padding-lg" v-else>
						<Icon type="ios-alert-outline" /> 未上传！
					</div>
			</div>

		<Modal v-model="modalCodeShow" title="输入查询码" :footer-hide="true" :width="520">
			<div style="position: relative;" class="padding-right-xl">
				<Form ref="formCode" :model="formCode" label-position="right" :label-width="100" label-colon>
					<FormItem label="查询码">
						<Input v-model="formCode.code" :maxlength="14" placeholder="查询码"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="submitCode('formCode')" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="modalCodeShow=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="loadingCode">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>加载中...</div>
				</Spin>
			</div>
		</Modal>

		<Modal v-model="modalModifyShow" title="修改" :footer-hide="true" :width="520">
			<div style="position: relative;" class="padding-right-xl">
				<Form ref="formModify" :model="formModify" label-position="right" :label-width="100" label-colon>
					<FormItem label="帐号状态">
						<RadioGroup v-model="formModify.state">
							<Radio label="1" border>正常</Radio>
							<Radio label="0" border>禁用</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="登陆密码">
						<Input v-model="formModify.pass" placeholder="不修改请留空"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="submitModify('formModify')" :loading="loadingModify" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="modalModifyShow=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="loadingModify">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>加载中...</div>
				</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userid: '',
				info: {
				},
				loading: false,
				modalModifyShow: false,
				loadingModify: false,
				formModify: {
					userid: '',
					state: "1",
					pass: ''
				},
				modalCodeShow: false,
				formCode: {
					code: ''
				},
				loadingCode: false
			};
		},
		methods: {
			loadinfo() {
				let postData = {
					userid: this.userid,
					code: this.formCode.code
				};
				this.$http.post('/server/api/sf/user/view.php?a=init', this.$qs.stringify(postData)).then(
					res => {
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.info = res.data.data.info;
							this.modalCodeShow = false;

						} else if (res.data.result == 'code') {
							this.$Message.error('请输入查询码');
							this.modalCodeShow = true;
							this.loadingCode = false;
						} else {
							this.$Message.error(res.data.msg);
							this.loadingCode = false;
						}
					},
					r => {
						this.$Message.error('系统错误');
					}
				);
			},
			submitCode() {
				this.loadingCode = true;
				this.loadinfo();

			},
			submitModify(name) {
				this.loadingModify = true;
				this.formModify.userid = this.userid;
				this.$http.post('/server/api/sf/user/view.php?a=modify', this.$qs.stringify(this.formModify)).then(
					res => {
						this.loadingModify = false;
						if (res.data.result == 'ok') {
							this.$Message.success('操作成功!');
							this.loadinfo();
							this.modalModifyShow = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingModify = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.userid = this.$route.params.id;
			this.loadinfo();
		}
	};
</script>

<style>
	img {
		display: block;
	}

	.imgbox {
		border: #ddd 1px solid;
		box-shadow: #aaa 0 0 8px;
	}

	.demo-spin-icon-load {
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
